import React from "react"
import Row from "@amzn/meridian/row";
import {FormattedMessage} from "react-intl";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Button from "@amzn/meridian/button";
import * as PropTypes from "prop-types";

const CancelConfirmModal = (props) => {

    const onCancel = () => {
        if (typeof props.data.cancelHandler === 'function') {
            props.data.cancelHandler();
        }
    }

    const onConfirm = () => {
        if (typeof props.data.confirmHandler === 'function') {
            props.data.confirmHandler();
        }
    }

    return <Modal minWidth={"500px"}
                  title="Confirmation Required"
                  open={props.data.visible}
                  onClose={onCancel}
                  scrollContainer="viewport"
                  closeLabel="Close">
        {/* Render the body content passed as props */}
        {props.data.innerHTML}
        <ModalFooter>
            <Row alignmentHorizontal="right" widths="fit">
                <Button data-modal-cancel-btn type="secondary" size="small" onClick={onCancel}>
                    <FormattedMessage id="route_prioritization_model.cancel" defaultMessage="Cancel"/>
                </Button>
                <Button data-modal-confirm-btn type="primary" size="small" onClick={() => onConfirm()}>
                    <FormattedMessage id="route_prioritization_model.confirm" defaultMessage="Confirm"/>
                </Button>
            </Row>
        </ModalFooter>
    </Modal>
}

CancelConfirmModal.propTypes = {
    data: PropTypes.shape({
        cancelHandler: PropTypes.func.isRequired,
        confirmHandler: PropTypes.func.isRequired,
        innerHTML: PropTypes.element.isRequired,
        visible: PropTypes.bool.isRequired
    })
};


export default CancelConfirmModal;


// WEBPACK FOOTER //
// ./src/components/commonModals/CancelConfirmModal.js